import { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPlus } = FiIcons;
const PRIORITIES = [
  { key: 'low', label: 'Low' },
  { key: 'medium', label: 'Medium' },
  { key: 'high', label: 'High' }
];

function TaskInput({ onAdd }) {
  const [title, setTitle] = useState('');
  const [priority, setPriority] = useState('medium');

  const submit = (event) => {
    event.preventDefault();
    const value = title.trim();
    if (!value) return;
    onAdd(value, priority);
    setTitle('');
    setPriority('medium');
  };

  return (
    <form className="task-input" onSubmit={submit}>
      <div className="task-input-row">
        <input
          value={title}
          onChange={(event) => setTitle(event.target.value)}
          placeholder="What needs your attention?"
          aria-label="New task"
        />
        <button type="submit" aria-label="Add task"><SafeIcon icon={FiPlus} /></button>
      </div>
      <div className="priority-picker" role="group" aria-label="Priority">
        {PRIORITIES.map(({ key, label }) => (
          <button
            type="button"
            key={key}
            className={`priority-pill priority-${key} ${priority === key ? 'active' : ''}`}
            onClick={() => setPriority(key)}
          >
            {label}
          </button>
        ))}
      </div>
    </form>
  );
}

export default TaskInput;